import { useLocation } from "react-router";
import { Footer } from "../blocks/Footer/Footer";
import { WorkPromo } from "../blocks/workpromo/workpromo";
import Header from "../components/header/header";
import "../core/core.css";
import { Services } from "../features/service-list/ui/Services";
import { canonicalPath } from "../utils/canonical";

import { Blog } from "../blocks/Blog/Blog";
import { ScrollBlock } from "../components/others/ScrollBlock";
import { CatalogMenu } from '../shared/components/MenuDown/MenuDown';

const blog = () => {
  const currentPage = useLocation();
  return (
    <>
      <title>{"Блог — HMREP"}</title>
      <link
        rel="canonical"
        href={`https://hmrep.ru${canonicalPath(currentPage.pathname)}`}
      />
      <meta
        name="description"
        content={
          "Рассказываем про скрытый маркетинг и диджитал.  Про отзывы и как их опубликовать на 2ГИС, Авито, Фламп и Яндекс."
        }
      />
      <div className="body">
        <ScrollBlock></ScrollBlock>
        <Header></Header>
        <div className="blocks">
          <Blog></Blog>
          <Services></Services>
          <WorkPromo></WorkPromo>
          <Footer></Footer>
        </div>
        <CatalogMenu></CatalogMenu>
      </div>
    </>
  );
};

export default blog;
